import styled from "styled-components";

import Spring from "../../../components/Spring";

export const StyledHome = styled(Spring)`
    position: relative;
    min-height: calc(100vh - 90px);
`;
